export default __webpack_public_path__ + "static/Ama_Luiz-3da29814f7839123129d70c72c4dae57.webp";